import styled from 'styled-components';
import { StyledDebtModal } from '../../../managers/reports/debt_list/debtList.styled';

export const StyledNoticeModal = styled(StyledDebtModal)`
    padding-right: 0 !important;

    .modal-content {
        padding: 62px 84px 111px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 18px;  
        text-align: center;
        font-family: var(--bllink-font-primary); 
        color: #373647;
        font-size: 18px;
        
        .close-btn {
            position: absolute;
            left: 24px;
            top: 24px;
        }

        .notice-modal-title {
            font-family: var(--bllink-font-headers);
            font-weight: 400;
            font-size: 28px;
        }
        
        .app-btn {
            margin-top: 44px;
            width: 214px;
            font-family: var(--bllink-font-headers);
            font-size: 20px;
            font-weight: 400;
        }
`
